import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import {CONFIG} from './config.js';

Vue.use(Vuex);


const store = new Vuex.Store({
    state: {
        shifts: [],
        token: null,
        tokenExpiresIn: null,
        tokenExpiredBackwardRoute: null,
        previousRoute: null
    },
    actions: {        
    },
    mutations: {
        setShifts (state, shifts) {
            state.shifts = shifts
        },
        setToken (state, token) {
            state.token = token;
            localStorage.token = token;
        },
        setTokenExpiresIn (state, expires) {
            state.tokenExpiresIn = expires;
            localStorage.expires = expires;
        },
        setTokenExpiredBackwardRoute(state, route) {
            state.tokenExpiredBackwardRoute = route != '/login' ? route : CONFIG.afterLoginRoute;
        },
        updateShiftById(state, {id, data}) {
            Object.assign(this.getters.getShiftById(id), data);
        },
        setPreviousRoute(state, route) {
            state.previousRoute = route;
        }
    },
    getters: {
        getShiftById: (state) => (id) => {
            return state.shifts.find(shift => shift.ord_shift_id == id);
        },
        isLoggedIn: (state) => {
            return !!state.token;
        },
        isTokenExpired: (state) => {
            return state.tokenExpiresIn != null && Date.now() > state.tokenExpiresIn;
        }
    }
})

export default store;
